import React from 'react';
import { IIconProps, Icon } from '@logz-ui/styleguide/components/icons/Icon.component';

export const InputIcon: React.FC<Partial<IIconProps>> = ({ icon = 'calendar-regular', ...props }) => {
  return <Icon icon={icon} size={12} {...props} />;
};
